import { Component } from '@angular/core';
import { ChildComponent } from 'src/app/components/child/child.component';

@Component({
  selector: 'app-provider-locations',
  templateUrl: './provider-locations.component.html',
  styleUrls: ['./provider-locations.component.scss'],
})
export class ProviderLocationsComponent extends ChildComponent {
  activeTab: 'locations' | 'depots' | 'configuration' = 'locations';

  constructor() {
    super();
  }

  setActiveTab(tab: 'locations' | 'depots' | 'configuration') {
    this.activeTab = tab;
  }
}
